var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoTextWrapper"},[_c('p',[_vm._v("\n    Få dina gavlar färdigmonterade istället för omonterade. Sparar tid vid montering och säkerställer att gavlarna är monterade på ett godkänt sätt.\n  ")])])
}]

export { render, staticRenderFns }